<template>
<div id="navigation">
  <div class="header">
    <div class="logo">
      <img :src="logo" alt="" width="50" height="50">
    </div>


    <multiselect class="select-app" v-model="selectedProject" placeholder="choose app" label="title" track-by="title" :options="projects" :allow-empty="false" :option-height="40" :show-labels="false">
      <template slot="singleLabel" slot-scope="props">
        <div class="inline" v-if="Object.entries(props.option).length !== 0">
          <img :src="props.option.logo" width="40" alt="app image">
          <span>
            <span>
              &nbsp;&nbsp;{{ props.option.title }}
            </span>
          </span>
        </div>
      </template>

      <template slot="option" slot-scope="props">
        <div class="inline">
          <img :src="props.option.logo" width="40" alt="app image">
          <div>
            <span>
              &nbsp;&nbsp;{{ props.option.title }}
            </span>
          </div>
        </div>
      </template>
    </multiselect>

  </div>

  <div class="wrapper">
    <slot :bundleId="selectedProject.bundleId" />
  </div>


</div>
</template>

<script>
// import Filtr from './components/Filtr.vue'
// import Loader from './components/Loader.vue'
import Multiselect from 'vue-multiselect'
// import Apps from '../resources/static/apps.json'
export default {
  name: 'navigation',
  components: {
    Multiselect,
    // Loader
  },
  data() {
    return {
      logo: require(`@/assets/logo.png`),
      projects: [{
          title: "Translator",
          bundleId: "app.voice-translator.ios",
        },
        {
          title: "Gum VPN",
          bundleId: "co.bosger.easyvpn",
        },
        {
          title: "Chamy VPN",
          bundleId: "com.prodinfire.vpn",
        },
      ],
      selectedProject: {},
    }
  },

  // beforeMount() {
  //   var redirect = false
  //   var query = { ...this.$route.query} || {}
  //   if (query.bundleId === undefined) {
  //     query.bundleId = projects[0].bundleId
  //     redirect = true
  //   } else {
  //     var found = false
  //     for (var i = 0; i < projects.length; i++) {
  //       if (query.bundleId==projects[i].bundleId) {
  //         selectedProject = projects[i]
  //       }
  //     }
  //     if (!found) {
  //       query.bundleId = projects[0].bundleId
  //       redirect = true
  //     }
  //   }
  //
  //   if (redirect == true) {
  //     this.$router.push({
  //       name: 'overview',
  //       query: query
  //     }).catch(() => {})
  //   }
  // },
  methods: {
    compare(a, b) {
      if (a.Count < b.Count) {
        return 1;
      }
      if (a.Count > b.Count) {
        return -1;
      }
      return 0;
    },
    showLoading() {
      this.loading = true
      this.$modal.show('loader');
    },
    hideLoading() {
      this.loading = false
      this.$modal.hide('loader');
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style><style lang="scss">@import '../assets/variables.scss';
#navigation {
.header {
  height: 8%;
  width: 100%;
  padding: 0 3% 0 3%;
  box-sizing: border-box;
  border-bottom: 2px solid #19A48A;
  display: flex;
  justify-content: space-between;
  .select-app {
    width: 400px;
  }
  .select-features {
    width: 600px;
  }
  .inline {
    display: inline-flex;
    align-items: center;
    padding: 5px;
  }
  .multiselect__tags {
    padding: 0 30px 0 0;
  }
  .multiselect__single {
    margin-bottom: 2px;
  }
}


.wholewidth {
  flex-shrink: 0;
}

.left {
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  min-width: 320px;
  width: auto;
}

// .right {
//   min-width: 1100px;
// }

.chart-divider {
  height: 20px;
}

.chart-events {
  height: calc(100vh - 30px);
}

.chart-retention {
  height: calc(100vh - 40px);
}

// .v--modal-box {
//   z-index: 500;
//   background-color: transparent !important;
//   display: table-cell;
//   text-align: center;
//   vertical-align: middle;
// }
}
</style>
